import { render, staticRenderFns } from "./OpacityScaleTransition.vue?vue&type=template&id=8e30b67a&"
import script from "./OpacityScaleTransition.vue?vue&type=script&lang=js&"
export * from "./OpacityScaleTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports